<template>
	<footer>
		<div class="container footer">
			<div class="top-bar">
				<div class="left-menu footer-menus main-menu">
					<ul>
						<li><router-link :to="'/aboutus'">About</router-link></li>
						<li class="dots"><i class="material-icons">circle</i></li>
						<li><router-link :to="'/privacy'">Privacy & Terms</router-link></li>
						<li class="dots"><i class="material-icons">circle</i></li>
						<li><router-link :to="getFAQUrl">FAQs</router-link></li>
						<li class="dots"><i class="material-icons">circle</i></li>
						<li><router-link :to="'/contact'">Contact Us</router-link></li>
					</ul>
				</div>
				<div class="right-menu footer-menus social">
					<ul>
						<li><a href="https://www.facebook.com/mtradeasia/" target="_blank"><img src="/static/commercial/img/icons/fb.png" alt=""></a></li>
						<li><a href="https://www.linkedin.com/company/merchantrade-asia-sdn-bhd/" target="_blank"><img src="/static/commercial/img/icons/in.png" alt=""></a></li>
						<li><a href="https://www.youtube.com/channel/UCqNixUpC8o9akwL2yZv1qvQ/videos" target="_blank"><img src="/static/commercial/img/icons/yt.png" alt=""></a></li>
						<li><a href="https://twitter.com/mtrade_asia?lang=en" target="_blank"><img src="/static/commercial/img/icons/tw.png" alt=""></a></li>
						<li><a href="https://www.instagram.com/merchantradeasia/" target="_blank"><img src="/static/commercial/img/icons/ig.png" alt=""></a></li>
					</ul>
				</div>
			</div>

			<div class="buttom-bar">
				<div class="left-menu footer-menus">
					<a href="https://mtradeasia.com/" target="_blank" class="logo">
						<img src="/static/commercial/img/merchantrade.jpg" alt="">
					</a>
					<p>An innovative product by Merchantrade Asia Sdn. Bhd. <br /> Malaysia’s Largest Money Services Provider</p>
				</div>
				<div class="right-menu footer-menus clients">
					<ul>
						<li><a href="https://www.mamsb.org.my/" target="_blank"><img src="/static/commercial/img/mamsb.png" alt=""></a></li>
						<li><a href="https://www.iamtn.org/" target="_blank"><img src="/static/commercial/img/iamtn.png" alt=""></a></li>
						<li><a href="https://www.paynet.my/" target="_blank"><img src="/static/commercial/img/fpx.png" alt=""></a></li>
						<li><a href="https://www.digicert.com/" target="_blank"><img src="/static/commercial/img/digicert.png" alt=""></a></li>
					</ul>
				</div>
			</div>
		</div>
		<div class="row copyright">
			<div class="col-md-3"></div>
			<div>
				<p>Copyright ©{{currentYear}}. Merchantrade Asia Sdn. Bhd. 199601038238 (410591-T). All Rights Reserved.</p>
			</div>
			<div class="col-md-3">
				<a href="https://www.fmos.org.my/en/feedback.html" target="_blank" class="logo">
					<img src="/static/commercial/img/logo_fmos.svg" alt="">
				</a>
			</div>
		</div>
	</footer>
</template>
<script>
	export default {
		computed: {
			getFAQUrl() {
				if ((this.$route.meta.pagetype || 1) === 1) {
					return "/faq";
				}
				return "/faq/business";
			},
			currentYear() {
				return new Date().getFullYear();
			},
		}
	}
</script>
